import React from "react";
import { motion } from "framer-motion";
import ResponsiveWrapper from "../../../../../components/common/ResponsiveWrapper";

const SuccessAnimation = ({ show, onHide, onContinue }) => (
    <ResponsiveWrapper show={show} onHide={onHide} animate drawerHeight="auto">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-w-full tw-min-h-[350px]">
            <motion.div
                className="tw-relative tw-flex tw-items-center tw-justify-center"
                initial={{ rotate: 0 }}
                animate={{ rotate: 360 }}
                transition={{ duration: 1.2, ease: "easeInOut" }}
            >
                {/* Filled green background circle */}
                <svg width="120" height="120" viewBox="0 0 120 120" className="tw-block tw-absolute">
                    <circle cx="60" cy="60" r="54" fill="#3CB371" />
                </svg>
                {/* Animated green stroke circle (counterclockwise fill) */}
                <motion.svg width="120" height="120" viewBox="0 0 120 120" className="tw-block">
                    <motion.circle
                        cx="60"
                        cy="60"
                        r="54"
                        fill="none"
                        stroke="#3CB371"
                        strokeWidth="10"
                        strokeDasharray={339.292}
                        strokeDashoffset={339.292}
                        animate={{ strokeDashoffset: 0 }}
                        transition={{ duration: 1.2, ease: "easeInOut" }}
                        style={{ transform: "rotate(-90deg)", transformOrigin: "50% 50%" }}
                    />
                </motion.svg>
                {/* Animated checkmark, fades in and draws after circle is filled */}
                <motion.svg
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    className="tw-absolute"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1.2, duration: 0.3, ease: "easeInOut" }}
                >
                    <motion.path
                        d="M15 32 L27 44 L45 18"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: 1 }}
                        transition={{ duration: 0.7, delay: 1.2, ease: "easeInOut" }}
                    />
                </motion.svg>
            </motion.div>
            <div className="tw-mt-6 tw-text-green-700 tw-text-2xl tw-font-bold tw-text-center">Added</div>
            <div className="tw-mb-6 tw-text-green-700 tw-text-base tw-text-center">
                New properties added to your feed
            </div>
            <button
                className="tw-bg-green-700 tw-text-white tw-px-8 tw-py-2 tw-rounded-lg tw-font-semibold tw-text-lg hover:tw-bg-green-800"
                onClick={onContinue}
            >
                Continue
            </button>
        </div>
    </ResponsiveWrapper>
);

export default SuccessAnimation;
